import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { ImportProvider } from "@prequel/import-react";

import { importClient } from "./api/import/sdk/client";
import { importApiRoutes } from "./api/import/sdk/routes";
import App from "./App";
import { AuthProvider } from "./providers/AuthProvider";
import { LightboxProvider } from "./providers/LightboxProvider";
import { QueryProvider } from "./providers/QueryProvider";
import { ToastProvider } from "./providers/ToastProvider";

import "./index.css";

const rootElement = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <StrictMode>
    <QueryProvider>
      <AuthProvider>
        <ToastProvider>
          <LightboxProvider>
            <ImportProvider client={importClient} routes={importApiRoutes}>
              <App />
            </ImportProvider>
          </LightboxProvider>
        </ToastProvider>
      </AuthProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryProvider>
  </StrictMode>,
);
